import { render, staticRenderFns } from "./hs-breadcrumb.vue?vue&type=template&id=6534abc1&scoped=true&"
import script from "./hs-breadcrumb.vue?vue&type=script&lang=js&"
export * from "./hs-breadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6534abc1",
  null
  
)

export default component.exports